export default __webpack_public_path__ + "static/media/domainpage-open-source-domain-tools.9b7dfe1a.jpg";